export default __webpack_public_path__ + "media/images/icons_button/boussole-fd46ebbab1442a7df12efafdfdc0baca.png";